import React, { useState, useEffect } from 'react';
import Story from './Story';
import Image from './Image';

function Show({ withImage, path_story, timeLimit, onTimeUp }) {
  const [hoveredSentence, setHoveredSentence] = useState(null);
  const [remainingTime, setRemainingTime] = useState(timeLimit);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainingTime((prevTime) => {
        if (prevTime <= 1000) {
          clearInterval(timer);
          onTimeUp();
          return 0;
        }
        return prevTime - 1000;
      });
    }, 1000);

    return () => clearInterval(timer); // クリーンアップ
  }, [timeLimit, onTimeUp]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <div className="flex flex-col w-full justify-center max-h-[calc(100vh-50px)] mt-2">
      <div className="flex w-full justify-center">
        <Story withImage={withImage} path_story={path_story} onHover={(sentenceIndex) => setHoveredSentence(sentenceIndex)} />
        {withImage && (
          <Image hoveredSentence={hoveredSentence} path_story={path_story} />
        )}
      </div>
      <div className="text-center mt-4">
        <p>Remaining Time: {formatTime(remainingTime)}</p> {/* 残り時間を表示 */}
      </div>
    </div>
  );
}

export default Show;
